import { BulkAddPage } from '@/components/words/bulk-add-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/words/bulk-add')({
  component: BulkAddPage,
});
